import { Wrench } from 'lucide-react';
import { ReactNode } from 'react';

interface ToolPageModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function ToolPageModal({ isOpen, onClose, title, children }: ToolPageModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-navy-900">
      <div className="h-full w-full flex flex-col">
        <header className="px-4 py-3 border-b border-navy-700 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Wrench className="w-4 h-4 text-blue-300" />
            <h2 className="text-sm font-semibold text-gray-100">Ferramentas • {title}</h2>
          </div>
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-white text-xs px-2 py-1 border border-navy-700 rounded"
          >
            Fechar
          </button>
        </header>
        <div className="flex-1 min-h-0">
          {children}
        </div>
      </div>
    </div>
  );
}
